import { render, staticRenderFns } from "./DetailSale.vue?vue&type=template&id=c61d6a38&scoped=true&"
import script from "./DetailSale.vue?vue&type=script&lang=js&"
export * from "./DetailSale.vue?vue&type=script&lang=js&"
import style0 from "./DetailSale.vue?vue&type=style&index=0&id=c61d6a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61d6a38",
  null
  
)

export default component.exports